import { Divider } from '@methanesat/ui-components';

export const DrawerDivider = () => <Divider sx={{ marginTop: 1, marginBottom: 2 }} />;
